<div class="time-input">
  <form #timeForm="ngForm">
    <input name="hours" type="text" [(ngModel)]="hours" #hoursInput (keydown)="hoursKeydown($event)"
           (focus)="select($event)" />:<input name="minutes" type="text" [(ngModel)]="minutes"
                                               #minutesInput (keydown)="minutesKeydown($event)"
                                              (focus)="select($event)"/>
    <input name="meridian" type="text" [(ngModel)]="meridian" #meridianInput (keydown)="meridianKeydown($event)"
           (focus)="select($event)"/>
  </form>
</div>